import Loadable from 'react-loadable';

import { Notifications } from '@atlaskit/navigation-system/top-nav-items';

import { useTopNavData } from './hooks';

// we should lazy load the platform notifs component to avoid pulling in deps
// during testing and improve runtime perf by only loading this code when needed
const PlatformNotificationsBase = Loadable({
  loading: () => null,
  loader: () =>
    import(
      'src/components/navigation/src/components/horizontal-nav/platform-notifications'
    ).then(module => ({
      default: module.PlatformNotificationsBase,
    })),
});

export const TopNavNotifications = (): JSX.Element => {
  const { currentWorkspace, defaultWorkspace } = useTopNavData();

  return (
    <PlatformNotificationsBase
      triggerComponent={Notifications}
      currentWorkspace={currentWorkspace}
      defaultWorkspace={defaultWorkspace}
    />
  );
};
